<template>
  <b-container fluid>
    <div class="border card-form mb-3">
      <b-row class="p-3">
        <b-col md="6" class="d-flex flex-column align-self-end">
          <label for="kind-fleet">Fleet Name *</label>
          <v-multiselect
            :multiple="false"
            track-by="id"
            placeholder="Select fleet"
            :options="fleetTypeOpt"
            label="name"
            value="id"
            id="kind-fleet"
            v-model="form.vehicle_type_ids"
          >
            <span slot="noResult"
              >Oops! No elements found. Consider changing the search query.</span
            >
          </v-multiselect>
        </b-col>
        <b-col md="6" class="d-flex flex-column mt-3">
          <label for="input-year">Year *</label>
          <date-picker
            id="input-year"
            class="w-100"
            type="year"
            v-model="form.year"
          ></date-picker>
        </b-col>
        <b-col md="12" class="mt-2">
          <b-row class="mt-2" v-for="(plans, index) in form.target_per_months" :key="index">
            <b-col md="12">
              <h6 class="text-sm text-primary font-weight-bold text-uppercase">{{ moment().month(index).format('MMMM') }}</h6>
            </b-col>
            <b-col md="3" class="d-flex flex-column">
              <label :for="`input-availability-${index}`">Plan Availability *</label>
              <b-input-group append="%">
                <b-form-input
                  :id="`input-availability-${index}`"
                  type="number"
                  v-model.number="plans.plan_availability"
                  @blur="(event) => handleValidateTargetAvailability(event, index, 'availability')"
                />
              </b-input-group>
              <b-form-invalid-feedback :state="plans.error_availability">
                Target tidak boleh melebihi dari 100%.
              </b-form-invalid-feedback>
            </b-col>
            <b-col md="3" class="d-flex flex-column">
              <label :for="`input-breakdown-${index}`">Plan Breakdown *</label>
              <b-input-group append="%">
                <b-form-input
                  :id="`input-breakdown-${index}`"
                  type="number"
                  v-model.number="plans.plan_breakdown"
                  @blur="(event) => handleValidateTargetAvailability(event, index, 'breakdown')"
                ></b-form-input>
              </b-input-group>
              <b-form-invalid-feedback :state="plans.error_breakdown">
                Target tidak boleh melebihi dari 100%.
              </b-form-invalid-feedback>
            </b-col>
            <b-col md="3" class="d-flex flex-column">
              <label :for="`input-docking-${index}`">Plan Docking *</label>
              <b-input-group append="%">
                <b-form-input
                  :id="`input-docking-${index}`"
                  type="number"
                  v-model.number="plans.plan_docking"
                  @blur="(event) => handleValidateTargetAvailability(event, index, 'docking')"
                ></b-form-input>
              </b-input-group>
              <b-form-invalid-feedback :state="plans.error_docking">
                Target tidak boleh melebihi dari 100%.
              </b-form-invalid-feedback>
            </b-col>
            <b-col md="3" class="d-flex flex-column">
              <label :for="`input-total-${index}`">Total</label>
              <b-input-group append="%">
                <b-form-input
                  :id="`input-total-${index}`"
                  type="number"
                  :value="getTotal(plans)"
                  disabled
                ></b-form-input>
              </b-input-group>
              <b-form-invalid-feedback :state="plans.error_total">
                Total harus mencapai 100%.
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="12" class="d-flex flex-column my-3">
          <label for="input-remarks">Remarks</label>
          <b-form-textarea
            id="input-remarks"
            v-model="form.remark"
            placeholder="Enter something..."
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        </b-col>
        <b-col md="12" class="d-flex justify-content-end my-3">
          <b-button variant="outline-primary" class="mr-2" outline @click="handleReset">
            Cancle and Close
          </b-button>
          <b-button v-if="!loading" variant="primary" @click="() => handleSubmit()" outline>
            Submit
          </b-button>
          <b-button v-else variant="primary" outline class="d-flex align-items-center px-3">
            <b-spinner small class="mr-2"></b-spinner>
            Loading...
          </b-button>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>
<script>
import moment from '@/node_modules/moment/moment'
import { fleetsActions, srActions, crewingActions } from '@/src/Utils/helper'

export default {
  name: 'FormTargetFleetAvailabilityYearly',
  props: {
    showForm: Boolean,
    forms: {
      type: Object,
      required: true,
      default: () => ({
        vehicle_type_ids: null,
        year: moment().toDate(),
        target_per_months: [
          {
            month: 1,
            plan_availability: 0,
            plan_breakdown: 0,
            plan_docking: 0,
            error_availability: true,
            error_breakdown: true,
            error_docking: true,
            error_total: false,
          },
          {
            month: 2,
            plan_availability: 0,
            plan_breakdown: 0,
            plan_docking: 0,
            error_availability: true,
            error_breakdown: true,
            error_docking: true,
            error_total: false,
          },
          {
            month: 3,
            plan_availability: 0,
            plan_breakdown: 0,
            plan_docking: 0,
            error_availability: true,
            error_breakdown: true,
            error_docking: true,
            error_total: false,
          },
          {
            month: 4,
            plan_availability: 0,
            plan_breakdown: 0,
            plan_docking: 0,
            error_availability: true,
            error_breakdown: true,
            error_docking: true,
            error_total: false,
          },
          {
            month: 5,
            plan_availability: 0,
            plan_breakdown: 0,
            plan_docking: 0,
            error_availability: true,
            error_breakdown: true,
            error_docking: true,
            error_total: false,
          },
          {
            month: 6,
            plan_availability: 0,
            plan_breakdown: 0,
            plan_docking: 0,
            error_availability: true,
            error_breakdown: true,
            error_docking: true,
            error_total: false,
          },
          {
            month: 7,
            plan_availability: 0,
            plan_breakdown: 0,
            plan_docking: 0,
            error_availability: true,
            error_breakdown: true,
            error_docking: true,
            error_total: false,
          },
          {
            month: 8,
            plan_availability: 0,
            plan_breakdown: 0,
            plan_docking: 0,
            error_availability: true,
            error_breakdown: true,
            error_docking: true,
            error_total: false,
          },
          {
            month: 9,
            plan_availability: 0,
            plan_breakdown: 0,
            plan_docking: 0,
            error_availability: true,
            error_breakdown: true,
            error_docking: true,
            error_total: false,
          },
          {
            month: 10,
            plan_availability: 0,
            plan_breakdown: 0,
            plan_docking: 0,
            error_availability: true,
            error_breakdown: true,
            error_docking: true,
            error_total: false,
          },
          {
            month: 11,
            plan_availability: 0,
            plan_breakdown: 0,
            plan_docking: 0,
            error_availability: true,
            error_breakdown: true,
            error_docking: true,
            error_total: false,
          },
          {
            month: 12,
            plan_availability: 0,
            plan_breakdown: 0,
            plan_docking: 0,
            error_availability: true,
            error_breakdown: true,
            error_docking: true,
            error_total: false,
          },
        ],
        is_same_input: false,
        remark: '',
      })
    }
  },
  data() {
    return {
      fleetTypeOpt: [],
      loading:false,
      isFormEdit: false,
    }
  },
  computed: {
    form: {
      get() {
        return this.forms;
      },
      set(value) {
        this.$emit("update:forms", value);
      }
    }
  },
  methods: {
    ...fleetsActions,
    ...srActions,
    ...crewingActions,
    async fetchFleetTypes() {
      try {
        const res = await this.fetchVehicles({ active: true, showAll: false, page: 1, perPage: 9999999 })
        this.fleetTypeOpt = res.data?.filter((vehicle) => !['HEAVY EQUIPMENT', 'MOTHER VESSEL'].includes(vehicle.vehicleType.name))
        if (this.form.vehicle_type_ids) {
          this.form.vehicle_type_ids = res.data.find(vehicle => vehicle.id === this.form.vehicle_type_ids);
        }
      } catch (error) {
        console.log(error)
      }
    },
    async handleSubmit() {
      // block submit when any month total !== 100
      const invalidTotals = this.form.target_per_months.some((p) => (this.getTotal(p) !== 100))
      if (invalidTotals) {
        // mark errors to show invalid feedback (valid only if total === 100)
        this.form.target_per_months.forEach((p) => { p.error_total = (this.getTotal(p) === 100) })
        this.$bvToast && this.$bvToast.toast('Total per bulan harus mencapai 100% sebelum submit.', { variant: 'danger', autoHideDelay: 3000 })
        return
      }
      if (this.isFormEdit) return this.handleUpdate();
      try {
        this.loading = true
        const newForm = {
          vehicle_id: this.form.vehicle_type_ids?.id || null,
          year: parseInt(moment(this.form.year).format('YYYY')),
          plan_data: this.form.target_per_months.map(({ error_breakdown, error_docking, error_availability, ...el }) => ({
            ...el,
          })),
          remark: this.form.remark,
        }
        const res = await this.createTargetAvailabilityYearlyVehicle({ data: newForm })
        this.$swal({
          title: 'Success',
          text: res.message,
          icon: 'success',
        })
      } catch (error) {
        this.$swal({
          title: 'Success',
          type: 'error',
          text: 'Failed Create Data!',
          icon: 'error',
        })
      } finally {
        this.handleReset()
        this.loading = false
        this.$emit('refetch')
      }
    },
    async handleUpdate() {
      // block update when any month total !== 100
      const invalidTotals = this.form.target_per_months.some((p) => (this.getTotal(p) !== 100))
      if (invalidTotals) {
        this.form.target_per_months.forEach((p) => { p.error_total = (this.getTotal(p) === 100) })
        this.$bvToast && this.$bvToast.toast('Total per bulan harus mencapai 100% sebelum submit.', { variant: 'danger', autoHideDelay: 3000 })
        return
      }
      try {
        this.loading = true
        const newForm = {
          vehicle_id: this.form.vehicle_type_ids?.id || null,
          year: parseInt(moment(this.form.year).format('YYYY')),
          plan_data: this.form.target_per_months.map(({ error_breakdown, error_docking, error_availability, ...el }) => ({
            ...el,
          })),
          remark: this.form.remark,
        }
        const res = await this.updateTargetAvailabilityYearlyVehicle({ data: newForm, id: this.form.id })
        this.$swal({
          title: 'Success',
          text: res.message,
          icon: 'success',
        })
      } catch (error) {
        this.$swal({
          title: 'Success',
          type: 'error',
          text: 'Failed Create Data!',
          icon: 'error',
        })
      } finally {
        this.loading = false
        this.$emit('refetch')
      }
    },
    handleChangeInput(value) {
      if (this.form.is_same_input) {
        this.form.target_per_months.forEach((item) => {
          item.percentage_target = value
        })
      }
    },
    handleReset(refetchData = true){
      this.form.vehicle_type_ids =  [];
      this.form.year =  moment().toDate();
      this.form.remark =  '';
      this.form.target_per_months.forEach((el)=>{
        el.percentage_target = 0
        el.plan_availability = 0
        el.plan_breakdown = 0
        el.plan_docking = 0
        el.error_availability = true
        el.error_breakdown = true
        el.error_docking = true
      });
      if (refetchData) {
        this.$emit('refetch')
      }
    },
    handleValidateTargetAvailability(event, idx, name) {
      const value = parseFloat(event.target.value || 0);
      const plans = this.form.target_per_months[idx];
      const {
        plan_availability,
        plan_breakdown,
        plan_docking,
       } = plans;
      const total = parseFloat(plan_availability || 0) + parseFloat(plan_breakdown || 0) + parseFloat(plan_docking || 0);
      if (value > total || total > 100) plans[`error_${name}`] = false;
      else if (value > 100) {
        plans[`error_${name}`] = false;
      } else {
        plans[`error_${name}`] = true;
      }
      const totalValue = this.getTotal(plans);
      // valid only when exactly 100
      plans.error_total = (totalValue === 100)
    },
    getTotal(plans) {
      const a = parseFloat(plans.plan_availability || 0)
      const b = parseFloat(plans.plan_breakdown || 0)
      const c = parseFloat(plans.plan_docking || 0)
      const total = (isNaN(a) ? 0 : a) + (isNaN(b) ? 0 : b) + (isNaN(c) ? 0 : c)
      return Number.isFinite(total) ? Number(total.toFixed(2)) : 0
    },
  },
  async mounted() {
    this.fetchFleetTypes()
    if (this.form.id) {
      this.isFormEdit = true;
    }
    // Normalize initial monthly values to 0 so inputs show 0 instead of empty
    if (Array.isArray(this.form.target_per_months)) {
      this.form.target_per_months.forEach((p) => {
        p.plan_availability = Number.isFinite(+p.plan_availability) ? +p.plan_availability : 0
        p.plan_breakdown = Number.isFinite(+p.plan_breakdown) ? +p.plan_breakdown : 0
        p.plan_docking = Number.isFinite(+p.plan_docking) ? +p.plan_docking : 0
      })
    }
  },
  destroyed() {
    this.handleReset(false)
  }
}
</script>
<style scoped>
.card-form {
  background: #f7f7f7;
  border-radius: 10px;
}
.overflow-auto {
  overflow: auto !important;
}
.relative {
  position: relative;
}
.col-month {
  min-width: 160px;
}
.sticky {
  position: sticky !important;
}
.col-1 {
  left: 0px !important;
  z-index: 20;
  min-width: 40px;
}
.col-2 {
  left: 40px !important;
  z-index: 20;
  min-width: 200px;
  max-width: 200px;
}
.col-3 {
  left: 240px !important;
  z-index: 20;
  min-width: 100px;
  max-width: 100px;
}
.col-4 {
  left: 340px !important;
  z-index: 20;
  min-width: 100px;
  max-width: 100px;
}
.col-5 {
  left: 440px !important;
  z-index: 20;
  min-width: 100px;
  max-width: 100px;
}
</style>
